var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-cover",class:[_vm.className, { 'is-downloaded': _vm.downloaded }],style:(_vm.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }